import { Col, Row, Button } from "antd";
import { BsCheckLg, BsFillArrowLeftCircleFill, BsFillTrashFill } from "react-icons/bs";
import { FaRegListAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import IntlMessages from "../../../../../../domain/utility/IntlMessages";
import { SpecificationAttributeDetailsDto } from "../../../../../../shared/services/specification-attribute/dto/specification-attribute-details-dto";

interface ICreateSpecificationAttributesHeaderProps {
    isSubmitting: boolean;
    specificationAttributeDetails?: SpecificationAttributeDetailsDto;
    handleSubmit: () => void;
    deleteSpecificationAttribute: () => void;
}
const CreateSpecificationAttributesHeader = (props: ICreateSpecificationAttributesHeaderProps) => {

    const { handleSubmit, isSubmitting, deleteSpecificationAttribute, specificationAttributeDetails } = props;

    const { messages } = useIntl();
    const navigate = useNavigate();

    return(
        <Row>
            <Col lg={16} sm={24}>
                <div className='text-title'>
                    <span className='icon-title'>
                        <FaRegListAlt />
                    </span>
                    {
                        specificationAttributeDetails ?
                            `${messages['specificationAttributes.editSpecificationAttributesDetails'].toString()} - ${specificationAttributeDetails?.Name}`
                        :   <IntlMessages id='specificationAttributes.addANewSpecificationAttributes' />
                    }
                    <small className='back-to-list' >
                        <BsFillArrowLeftCircleFill className="back-to-icon" />
                        <a 
                            onClick={() => {
                                navigate("/catalog/catalog.attributes/specification-attributes");
                            }}
                        >
                            <IntlMessages id='specificationAttributes.backToSpecificationAttributesList' />
                        </a>
                    </small>
                </div>
            </Col>
            <Col lg={8}>
                <Row justify="end" gutter={[20, 0]}>
                    <Col>
                        <Button
                            icon={<BsCheckLg className="add-button-icon" />}
                            onClick={handleSubmit}
                            type="primary"
                            size='small'
                            className="add-button"
                            loading={isSubmitting}
                        >
                            <IntlMessages id="common.save" />
                        </Button>
                    </Col>
                    {
                        specificationAttributeDetails && (
                            <Col>
                                <Button
                                    icon={<BsFillTrashFill className="add-button-icon" />}
                                    onClick={deleteSpecificationAttribute}
                                    size='small'
                                    className="add-button"
                                >
                                    <IntlMessages id="common.delete" />
                                </Button>
                            </Col>
                        )
                    }
                </Row>
            </Col>
        </Row>
    );
};

export default CreateSpecificationAttributesHeader;